import type { SWRConfiguration } from 'swr'
import useSWR from 'swr'

import { PaymentsBalance } from '../types'
import { getBalance } from '../api/paymentsApi'

export default function usePaymentsBalance(options?: SWRConfiguration) {
  return useSWR<PaymentsBalance, Error>('payments/balance', getBalance, options)
}
